// extracted by mini-css-extract-plugin
export default {"skeleton":"challenges_skeleton__W4jk-","shimmer":"challenges_shimmer__OGqWf","tableContainer":"challenges_tableContainer__QIn7y","headerView":"challenges_headerView__ddk1c"};